export default __webpack_public_path__ + "static/media/portadavideoconfiguracion3.f5e52c5a.png";